
const Legend = (props) => {
  return (
    <div
      id="legend"

      style={{
        position: "absolute",
        top: 0,
        left: props.width,
        transform: "translate(-100%,0)", //-105
        zIndex: 100,
        width: 155,
      }}
    >
      <div style={{ position: "relative" }} id="container">
        <div id="legend-tab">
          <p>
            <strong>Legend</strong>
          </p>
        </div>
        <div id="legend-content">
          <svg width={130} height={135}>
            <defs>
              <clipPath id="middle-rect">
                <rect x="-15" y="-6" width="30" height="12" />
              </clipPath>
            </defs>
            <g id="color">
              <circle
                fill="#075875"
                stroke="#fff"
                strokeWidth={0.5}
                r={10}
                cx={15}
                cy={15}
              />
              <text
                transform={`translate(35,19)`}
                style={{ fontSize: "0.7em", fill: "white" }}
              >
                Political Violence
              </text>
              <circle
                fill="#ff833b"
                stroke="#fff"
                strokeWidth={0.5}
                r={10}
                cx={15}
                cy={41}
              />
              <text
                transform={`translate(35,45)`}
                style={{ fontSize: "0.7em", fill: "white" }}
              >
                Demonstrations
              </text>
            </g>
            <g id="scale" transform="translate(30,65)">
              <text
                className="scale-legend-title"
                transform={"translate(-4,15)"}
              >
                Event Count
              </text>
              <g transform={`translate(20,25)`}>
                <circle
                  clipPath="url(#middle-rect)"
                  className="scale-legend-circle"
                  r={props.sizeScale.range()[0]}
                />
                <text
                  className="scale-legend-label"
                  transform={`translate(25,4)`}
                >
                  {props.sizeScale.domain()[0]}
                </text>
              </g>
              <g transform={`translate(20,38)`}>
                <circle
                  clipPath="url(#middle-rect)"
                  className="scale-legend-circle"
                  r={props.sizeScale.range()[1] / 2}
                />
                <text
                  className="scale-legend-label"
                  transform={`translate(25,4)`}
                >
                  {Math.round(props.sizeScale.domain()[1] / 2)}
                </text>
              </g>
              <g transform={`translate(20,53)`}>
                <circle
                  clipPath="url(#middle-rect)"
                  className="scale-legend-circle"
                  r={props.sizeScale.range()[1]}
                />
                <text
                  className="scale-legend-label"
                  transform={`translate(25,4)`}
                >
                  {props.sizeScale.domain()[1]}
                </text>
              </g>
            </g>
          </svg>
          <p id="methodology-link">
            <a href="#methodology">Methodology</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Legend;
